import axios from "axios";

export function getUserStsTempByEmail(email) {
  const config = {
    params: {
      email: email,
    },
  };
  return axios.get(process.env.VUE_APP_API_URL + "UserStsTemp/get", config);
}
